import { createActionHelpers } from 'vuex-loading';
import _ from 'lodash';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    description: '',
    effectiveDate: null,
    list: [],
    product_list: [],
    planogram_list: [],
    dimensionList: [],
    sequenceList: [],
    facingList: [],
    totalProductList: 0,
    countPlanogramProduct: [],
};

const mutations = {
    setDescription(state, description) {
        state.description = description;
    },

    setEffectiveDate(state, effectiveDate) {
        state.effectiveDate = effectiveDate;
    },

    setList(state, data) {
        state.list = data;
    },

    setProductList(state, product_list) {
        state.product_list = product_list;
    },

    setPlanogramList(state, planogram_list) {
        state.planogram_list = planogram_list;
    },
    setSequence(state, data) {
        state.sequenceList = data;
    },

    setFacings(state, data) {
        state.facingList = data;
    },

    setDimensionList(state, data) {
        state.dimensionList = data;
    },

    setTotalProductList(state, data) {
        state.totalProductList = data;
    },

    setPlanogramProduct(state, data) {
        state.countPlanogramProduct = data;
    },
};

const getters = {
    description: state => {
        return state.description;
    },

    effectiveDate: state => {
        return state.effectiveDate;
    },

    planogramNameList: state => {
        return state.list.map(s =>
            Object.assign({
                id: s.id,
                name: s.full_name,
            }),
        );
    },

    sequenceList: state => {
        return state.sequenceList.map(s =>
            Object.assign({
                product_id: s.id,
                sequence: s.sequence,
            }),
        );
    },

    facingList: state => {
        return state.facingList.map(s =>
            Object.assign({
                product_id: s.id,
                sequence: s.sequence,
                facings: s.facings,
            }),
        );
    },

    dimensionList: state => {
        return state.dimensionList.map(s =>
            Object.assign({
                id: s.id,
                name: s.name,
            }),
        );
    },

    groupDimensionList: state => {
        return _.groupBy(state.dimensionList, 'group_name');
    },

    totalProductCount: state => state.totalProductList,

    countPlanogramProduct: state => state.countPlanogramProduct,
};

const actions = {
    async getList({ commit, dispatch }, params) {
        startLoading(dispatch, 'fetch-planogram-list');
        const response = await axios.get(
            Laroute.route('franchise.inventory.planogram.planogram_list'),
            { params },
        );
        commit('setList', response.data);
        endLoading(dispatch, 'fetch-planogram-list');
    },
    async getProductList({ commit, dispatch }, params) {
        const response = await axios.get(
            Laroute.route('franchise.inventory.planogram.all_product_list'),
            { params },
        );
        commit('setProductList', response.data);
    },
    toggleLoader({ commit, dispatch }, { name, start = true }) {
        start ? startLoading(dispatch, name) : endLoading(dispatch, name);
    },
    async getDimensionList({ commit, dispatch }) {
        startLoading(dispatch, 'fetch-dimension');
        const response = await axios.get(
            Laroute.route('franchise.inventory.planogram.dimension_list'),
        );
        commit('setDimensionList', response.data);
        endLoading(dispatch, 'fetch-dimension');
    },
    async getTotalProductList({ commit, dispatch }, params) {
        const { data: productCount } = await axios.get(
            Laroute.route('franchise.inventory.planogram.total_product_list'),
            { params },
        );
        commit('setTotalProductList', productCount);
    },
    async getCountPlanogramProduct({ commit, dispatch }, params) {
        const { data } = await axios.get(
            Laroute.route(
                'franchise.inventory.planogram.count_planogram_product',
            ),
            { params },
        );
        commit('setPlanogramProduct', data);
    },
    async getProductSequence({ commit, dispatch }, params) {
        startLoading(dispatch, 'fetch-planogram-list');
        const response = await axios.get(
            Laroute.route(
                'franchise.inventory.planogram.product_sequence_list',
            ),
            { params },
        );
        commit('setSequence', response.data);
        endLoading(dispatch, 'fetch-planogram-list');
    },

    async getProductFacing({ commit, dispatch }, params) {
        startLoading(dispatch, 'fetch-planogram-list');
        const response = await axios.get(
            Laroute.route('franchise.inventory.planogram.product_facing_list'),
            { params },
        );
        commit('setFacings', response.data);
        endLoading(dispatch, 'fetch-planogram-list');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/planogram.js